import React from "react";
import GenericPullConfigListing from "../GenericPullConfigListing";
import SentinelOneCredentialsForm from "./SentinelOneCredentialsForm";
import SentinelOneMappingForm from "./SentinelOneMappingForm";
import { isNull } from "utils/lodashUtils";
import { CellRenderers, columnRenderArrayData } from "utils/tableUtils";

const SentinelOneConfigListing = (props) => {
  const columns = () => [
    {
      title: "Tag Key",
      dataIndex: "tags",
      width: 200,
      render: (tags, record) =>
        !tags
          ? CellRenderers.VALUE_OR_NA()
          : CellRenderers.VALUE_OR_NA(Object.keys(JSON.parse(tags)).join(", ")),
    },
    {
      title: "Tag Value",
      dataIndex: "tags",
      width: 200,
      render: (tags, record) =>
        !tags
          ? CellRenderers.VALUE_OR_NA()
          : CellRenderers.VALUE_OR_NA(
              Object.values(JSON.parse(tags)).flat().join(", ")
            ),
    },
    {
      title: "Endpoints",
      dataIndex: "endpoints",
      render: (endpoint, record) =>
        isNull(endpoint) ? "All" : columnRenderArrayData(endpoint),
      width: 200,
    },
  ];
  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={SentinelOneMappingForm}
      CredentialsForm={SentinelOneCredentialsForm}
      extraColumns={columns}
    />
  );
};

export default SentinelOneConfigListing;
